if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
/* ===== Desktop swap (no modal on desktop) - append block (FIXED) ===== */
(function () {
  const mqDesktop = window.matchMedia('(min-width: 990px)');

  function eachGallery(cb) {
    document.querySelectorAll('media-gallery[id^="MediaGallery-"]').forEach(cb);
  }

  function applyDesktopMode(galleryEl) {
    galleryEl.querySelectorAll('[data-modal]').forEach((el) => {
      if (!el.hasAttribute('data-modal-original')) {
        el.setAttribute('data-modal-original', el.getAttribute('data-modal') || '');
      }
      el.removeAttribute('data-modal');
    });
    galleryEl.classList.add('swap-enabled');
  }

  function applyMobileMode(galleryEl) {
    galleryEl.querySelectorAll('[data-modal-original]').forEach((el) => {
      const val = el.getAttribute('data-modal-original');
      if (val !== null) el.setAttribute('data-modal', val);
      el.removeAttribute('data-modal-original');
    });
    galleryEl.classList.remove('swap-enabled');
  }

  function initSwap(galleryEl) {
    const sectionId = galleryEl.id.replace('MediaGallery-', '');
    const mainWrap  = document.getElementById(`MainMedia-${sectionId}`);
    const list      = galleryEl.querySelector('.product__media-list');
    if (!mainWrap || !list) return;

    const mainImg = mainWrap.querySelector('img');
    if (!mainImg) return;

    // 捕捉フェーズでモーダル起動を抑止（ただしサムネのクリックは伝播を許可）
    const blocker = (ev) => {
      if (!mqDesktop.matches) return;
      const t = ev.target;
      if (!t) return;

      const inMainList = !!t.closest('.product__media-list');
      const hitsModal =
        t.closest('.product__modal-opener') ||
        t.closest('.product__media-toggle') ||
        t.closest('.deferred-media__poster');

      if (!hitsModal) return;

      ev.preventDefault(); // 既定（モーダル起動）だけ止める
      if (!inMainList) {
        ev.stopPropagation();
        if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
      }
    };
    galleryEl.addEventListener('click', blocker, true);
    galleryEl.addEventListener('keydown', (ev) => {
      if (!mqDesktop.matches) return;
      const t = ev.target;
      if (!t) return;
      const inMainList = !!t.closest('.product__media-list');
      const hitsModal =
        t.closest('.product__modal-opener') ||
        t.closest('.product__media-toggle') ||
        t.closest('.deferred-media__poster');
      const key = ev.key || '';
      if (hitsModal && (key === 'Enter' || key === ' ' || ev.keyCode === 13 || ev.keyCode === 32)) {
        ev.preventDefault();
        if (!inMainList) {
          ev.stopPropagation();
          if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();
        }
      }
    }, true);

    // PC：サムネクリックで上部メインへ差し替え
    list.addEventListener('click', (ev) => {
      if (!mqDesktop.matches) return;

      const item = ev.target.closest('.product__media-item');
      if (!item) return;

      ev.preventDefault();

      const container = item.querySelector('.product-media-container');
      if (!container) return;

      const type = container.dataset.mediaType;
      if (type && type !== 'image') return;

      const full = container.dataset.fullUrl;
      const alt  = container.dataset.alt || '';
      if (!full) return;

      mainImg.src = full;
      mainImg.srcset = '';
      mainImg.alt = alt;

      galleryEl.querySelectorAll('.product__media-item.is-active').forEach((el) => el.classList.remove('is-active'));
      item.classList.add('is-active');

      const counterCurrent = galleryEl.querySelector('.slider-counter--current');
      if (counterCurrent) {
        const posAttr = item.getAttribute('data-media-position') || item.dataset.mediaPosition;
        const indexFallback = Array.from(item.parentNode.children).indexOf(item) + 1;
        counterCurrent.textContent = posAttr || indexFallback;
      }
    }, { passive: false });

    if (mqDesktop.matches) applyDesktopMode(galleryEl);
  }

  window.addEventListener('load', () => {
    eachGallery(initSwap);
    mqDesktop.addEventListener('change', (e) => {
      eachGallery((galleryEl) => {
        if (e.matches) applyDesktopMode(galleryEl);
        else applyMobileMode(galleryEl);
      });
    });
  });
})();
